import { TreatmentType } from 'app/core/enums';

export const DS2_0TreatmentTypesSorted = [
    TreatmentType.AICrown,
    TreatmentType.AINightGuard,
    TreatmentType.AIRetainer,
    TreatmentType.DentalModel,
    TreatmentType.BracketRemoval,
    TreatmentType.CrownAndBridge,
    TreatmentType.HybridDentures,
    TreatmentType.ImplantRestorations,
    TreatmentType.SurgicalGuide,
    TreatmentType.ClearAligner,
    TreatmentType.CustomBleachingTray,
    TreatmentType.NightGuard,
    TreatmentType.RemovableDentures,
    TreatmentType.SmileCorrect,
    TreatmentType.SmileDesign,
    TreatmentType.SingleImplantWithCrown,
    TreatmentType.Veneers,
];
export const DS2_0TreatmentTypes = [
    TreatmentType.AINightGuard,
    TreatmentType.NightGuard,
    TreatmentType.SmileDesign,
    TreatmentType.RemovableDentures,
    TreatmentType.SurgicalGuide,
    TreatmentType.SingleImplantWithCrown,
    TreatmentType.ClearAligner,
    TreatmentType.SmileCorrect,
    TreatmentType.HybridDentures,
    TreatmentType.CustomBleachingTray,
    TreatmentType.Veneers,
    TreatmentType.CrownAndBridge,
    TreatmentType.AICrown,
    TreatmentType.AICrownWithCAD,
    TreatmentType.AICrown,
    TreatmentType.AIRetainer,
    TreatmentType.DentalModel,
    TreatmentType.ImplantRestorations,
    TreatmentType.ManualRetainer,
];

export const StudioTreatmentTypes = [TreatmentType.AICrownWithCAD];

interface DSOTreatmentTypeOption {
    excludeOrganizations?: string[];
}

const dso2_0TreatmentTypes: [TreatmentType, DSOTreatmentTypeOption][] = [
    [TreatmentType.Veneers, {}],
    [TreatmentType.AINightGuard, {}],
    [TreatmentType.SurgicalGuide, {}],
    [TreatmentType.CrownAndBridge, {}],
    [TreatmentType.AICrown, {}],
    [TreatmentType.RemovableDentures, {}],
    [TreatmentType.HybridDentures, {}],
    [TreatmentType.NightGuard, {}],
    [TreatmentType.ClearAligner, {}],
    [TreatmentType.CustomBleachingTray, {}],
    [TreatmentType.SmileCorrect, {}],
    [TreatmentType.SmileDesign, {}],
    [TreatmentType.SingleImplantWithCrown, {}],
    [TreatmentType.AIRetainer, {}],
    [TreatmentType.DentalModel, {}],
    [TreatmentType.ImplantRestorations, {}],
    [TreatmentType.ManualRetainer, {}],
];

export const DS2_0TreatmentTypesForDSO = (organizationId: string): TreatmentType[] =>
    (!organizationId
        ? []
        : dso2_0TreatmentTypes.filter(
              ([, options]) =>
                  options.excludeOrganizations == null ||
                  options.excludeOrganizations.length <= 0 ||
                  !options.excludeOrganizations.includes(organizationId)
          )
    ).map(([key]) => key);

export const PrintServiceTreatmentTypes = [
    TreatmentType.NightGuard,
    TreatmentType.Veneers,
    TreatmentType.AINightGuard,
    TreatmentType.DentalModel,
];

export const SkipDetailsTreatmentTypes = [];

export const NGOcclusalThicknessQuestionId = 7;

export const NGBiteScanTypeQuestionId = 10;

export const RetainerPalateQuestionId = 3;
